import { DownloadLinkConfig } from '../../models/indexPageVariant';

export const onConfig: DownloadLinkConfig = {
  android: 'https://downloads.xpoint.tech/verify-playstore.lnk',
  ios: 'https://downloads.xpoint.tech/ios-appstore.lnk',
  mac: 'https://downloads.xpoint.tech/xpoint-web-sdk-3.24.0.dmg',
  windows: 'https://downloads.xpoint.tech/xpoint-web-sdk-3.24.0.exe'
};
